import React from "react";
import { withStyles } from "@material-ui/core";
import { SaveAltSharp ,Fullscreen, FullscreenExit} from "@material-ui/icons";
import SearchBox from "../../../../common/SearchBox";
import Tooltip from "../../../../common/StyledToolTip";
import PrintIcon from "../../../../common/PrintReport/PrintIcon";
import RefreshBar from "../../../Common/RefreshBar";
import ClearAllFilterButton from '@dataGrid/components/columnFilters/ClearAllFilterButton';
import ShowHideColumns from "../../../../../layout/layoutHeader/showHideColumns";

const styles = (theme) => ({
  moduleHeader: {
    color: theme.HeaderSelectedText,
    borderBottom: `1px solid ${theme.AppBGColor}`,
    fontWeight: "bold",
    fontSize: theme.headerTextFontSize,
    padding: "2px 10px 8px 12px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  gridActionIcons: {
    display: "flex",
    alignItems: "center",
    float: "right",
  },
  headerIconStyles: {
    padding: "5px 10px",
    borderLeft: `1px solid ${theme.AppBGColor}`,
    cursor: "pointer",
    color: theme.iconColor,
  },
  customSearchClass: {
    minWidth: 200,
  },
});

const Header = ({
  classes,
  exportCSV,
  title,
  gridApi,
  printRef,
  onBeforeGetContent,
  updateQuickFilterText,
  showPrint = false,
  handleRefreshClick = null,
  isMaximized = false,
  toggleMaximize,
  headerId,
  userProfile
}) => {
  return (
    <header className={classes.moduleHeader}>
      <span>{title}</span>
      <div className={classes.gridActionIcons}>
        {handleRefreshClick && (
          <RefreshBar handleRefreshClick={handleRefreshClick} headerId={headerId}/>
        )}
        <SearchBox onChange={updateQuickFilterText} customSearchClass = {classes.customSearchClass}/>
        {gridApi?.getAllGridColumns && (
          <span className={classes.headerIconStyles}>
            <ShowHideColumns api={gridApi} userData={{ userProfile }} />
          </span>
        )}
        <ClearAllFilterButton gridApi={gridApi}/>
        {showPrint && (
          <PrintIcon
            tooltipText="Print report data"
            printRef={printRef}
            onBeforeGetContent={onBeforeGetContent}
          />
        )}
        <span onClick={exportCSV} className={classes.headerIconStyles}>
          <Tooltip title="Export Data">
            <SaveAltSharp />
          </Tooltip>
        </span>
        <span className={classes.headerIconStyles} onClick={toggleMaximize}>
          <Tooltip title={isMaximized ? 'Minimize' : 'Maximize'}>
            {isMaximized ? <FullscreenExit /> : <Fullscreen />}
          </Tooltip>
        </span>
      </div>
    </header>
  );
};

export default withStyles(styles)(Header);
